export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_5-43f9426d62c7cfb4596557f7fb6d844c.mp4";